<script lang="ts">
  import { onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config.js';
  import { isMobileWidth } from '../../../common/util';
  import Popup from '../../common/components/Popup.svelte';
  // import Swiper and modules styles
  import { Swiper } from 'swiper';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import { Pagination } from 'swiper/modules';

  export let highlights;
  let openContentPopup = false;
  const isResponsive = isMobileWidth();
  const { lang } = getAppConfig();
  interface Highlight {
    uid: string;
    uuid: string;
    typeCode: string;
    modifiedtime: string;
    container: string;
    externalUrl: string;
    synchronizationBlocked: string;
    description: string;
    url: string;
    htmlContent: string;
  }

  let popupContent = '';
  let swiperDOM;
  let swiper: Swiper | null = null;

  let swiperClass = '';
  let swiperClassWrapper = '';
  let swiperClassSlide = '';
  let surfaceStyle = 'max-width: 944px;width:944px;height:770px;min-height:770px;max-height:770px;border-radius: 24px;';
  if (isResponsive) {
    swiperClass = 'swiper';
    swiperClassWrapper = 'swiper-wrapper';
    swiperClassSlide = 'swiper-slide';
    surfaceStyle = 'max-width: 100vw;width:94vw;min-height:60vh;max-height:90vh;border-radius: 24px;';
  }

  function initSwiper() {
    if (!swiper) {
      swiper = new Swiper(swiperDOM, {
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        modules: [Pagination],
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  }
  function destroySwiper() {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  }
  onMount(() => {
    if (isResponsive) {
      initSwiper();
    }
    return destroySwiper;
  });

  function handleHighlightClick(e: MouseEvent, highlight: Highlight) {
    const target = e.target as HTMLElement;
    const link = target.closest('a');

    if (!link) {
      return;
    }

    const isExternalUrl = String(highlight.externalUrl) === 'true';

    if (isExternalUrl) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.href = highlight.url;
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    popupContent = highlight.htmlContent;
    openContentPopup = true;
  }

  function closePopup() {
    openContentPopup = false;
    popupContent = '';
  }
</script>

<div class="{swiperClass} c_highlights" bind:this={swiperDOM} dir={lang === 'ar' ? 'rtl' : ''}>
  <div class={swiperClassWrapper}>
    {#each highlights as highlight}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="{swiperClassSlide} hightlight-item gap-3" on:click={e => handleHighlightClick(e, highlight)}>
        <div class="hightlight-content">
          <div class="c_tick left"></div>
          {@html highlight.description}
        </div>
      </div>
    {/each}
  </div>
  <div class="swiper-pagination"></div>
</div>
<Popup bind:open={openContentPopup} content={popupContent} on:close={closePopup} {surfaceStyle} />

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .c_highlights {
    :global {
      .swiper-pagination-bullet {
        width: 40px;
        height: 4px;
        border-radius: 999px;
        margin: 0 5px;
        background: $color-grey-border-02;
        opacity: 1;
      }
      .swiper-pagination-bullet-active {
        background: $jood-blue-medium-01;
      }
    }
  }
</style>
